// extracted by mini-css-extract-plugin
module.exports = {"container":"dIg75tF","threeLineLayout":"WlEuo5p","reducedPrice":"_22sbBtS","saleAmount":"_3VjzNxC"};